import { useEffect, useMemo, useState } from 'react'

type CustomerSegment = {
  groupStatus: string
  requestedGroup: string
  requestedGroupName: string
}

const useCustomerSegments = () => {
  const [customerSegment, setCustomerSegment] =
    useState<CustomerSegment | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const fetchCustomerSegment = useMemo(
    () => async () => {
      setLoading(true)
      try {
        const request = await fetch('/api/account/get-customer-group', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        const response = await request.json()
        setCustomerSegment(response.data)
      } catch (err) {
        setError('Failed to fetch customer group')
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  useEffect(() => {
    fetchCustomerSegment()
  }, [fetchCustomerSegment])

  const requestNewCustomerSegment = async (groupId: string) => {
    // if (
    //   customerSegment?.segment !== newSegment &&
    //   customerSegment?.segmentStatus !== 'AWAITING_APPROVAL'
    // ) {
    await fetch('/api/account/request-customer-segment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        groupId,
      }),
    })

    await fetchCustomerSegment()
    // }
  }

  return {
    customerSegment,
    loading,
    error,
    refetch: fetchCustomerSegment,
    requestNewCustomerSegment,
  }
}

export default useCustomerSegments
